import { Helmet } from 'react-helmet';

import parsley from '../../components/vid/vlcsnap-parsley.webp';
import parsleyVid from '../../components/vid/parsley720.mp4';
import Logo from './Logo';

export default function Home() {
  const parsleyStart =  process.env.PUBLIC_URL+'/parsleyStart.webp';

  return (
    <section className='home-page'>
      <Helmet>
        <meta charset="UTF-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Plannt.ca | The Ultimate Garden Planning Tool for Square Foot Gardeners</title>
        <meta name="description" content="Let's grow food from seed! Use Plannt to build an interactive map of your garden, generate your personalized schedule, and keep track of your tasks all growing season long."></meta>
        <link rel="canonical" href="https://www.plannt.ca/"/>
      </Helmet>
      <div className='home-info-panel' itemScope itemProp="mainEntity" itemType="https://schema.org/WebApplication">
        <Logo/>
        <div className="layer-cont">
          <div className='video-overlay'>
            <h1 className="big-motto text-bg" style={{maxWidth:"16.6em", paddingLeft:"0.25em", borderRadius: "0.5em"}}><div className='guess'>Plant</div> with an emphasis on the <div className='guess italic'>plan.</div></h1>
            <div className="home-blurb">
              <h2 className='text-bg' style={{width:"8.25em", paddingBottom:"0.5em", paddingTop:"0", borderRadius: "0.75em 0.75em 0em 0em"}}>Thanks for visiting.</h2>
              <h2 className='text-bg'><span className="plannt lighter" itemProp="name">plannt.ca</span> is no <span itemProp="description">longer in operation.  We have decided to turn a new leaf</span>!</h2>
              <h2 className='text-bg' style={{width:"10.25em", paddingTop:"0.5em", borderRadius: "0em 0em 0.75em 0.75em"}}>Never stop growing. 💚</h2>
            </div>
          </div>
          <video autoPlay muted loop id="fullscreen-video" poster={parsleyStart} controlsList="nodownload" preload="auto" playsInline>
            <source src={parsleyVid} type="video/mp4" fetchpriority="high"/>
            <img src={parsley} width="1920" height="1080" alt="Parsley plant growing in the ground"/>
          </video>
        </div>
      </div>
      <div className='footer-span'>
        <div className='footer-panel'>
          <div className="copyright-msg"><p>Made with ❤️ in Canada</p></div>
          <div className="copyright-msg"><p>Copyright &copy; 2025 Plannt Solutions.  All rights reserved.</p></div>
        </div>
      </div>
    </section>
  );
}